import { Select } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.tsx';
import { FilterTableFieldName } from './types.ts';

export const BooleanSelect = ({ name }: { name: FilterTableFieldName }) => {
  const { control } = useFormContext();
  return (
    <Td colSpan={2} type="editable">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <Select
            id={name}
            options={[
              {
                label: 'Yes',
                value: 'true',
              },
              {
                label: 'No',
                value: 'false',
              },
            ]}
            size="sm"
            border={false}
            radius={false}
            isInvalid={fieldState.invalid}
            {...field}
            onChange={(value) => {
              if (value === 'true') {
                field.onChange(true);
              } else if (value === 'false') {
                field.onChange(false);
              } else {
                field.onChange('');
              }
            }}
            placeholder=" "
          />
        )}
      />
    </Td>
  );
};
